import React from "react";
import Lottie from "lottie-react";
import LoadingAnimation from "../../../assets/images/gif/sdap-loading.json";
import "./Loading.scss";

/**
 * A loading spinner component with Lottie animation.
 *
 * @description Loading renders a centered loading spinner using a Lottie animation.
 * It displays a 60x60 pixel animated loading indicator that loops continuously.
 * Use this component to indicate loading states in the application.
 *
 * Features:
 * - Lottie-based animation for smooth loading indicator
 * - Continuous loop animation
 * - Centered display with loading-screen styling
 *
 * @returns {JSX.Element} A div containing the loading animation
 *
 * @example
 * // Basic usage
 * {isLoading && <Loading />}
 *
 * @example
 * // Conditional rendering
 * function MyComponent({ data, isLoading }) {
 *   if (isLoading) {
 *     return <Loading />;
 *   }
 *   return <div>{data}</div>;
 * }
 */
const Loading = () => {
  return (
    <div className="loading-screen">
      <Lottie
        className="loading-screen__spinner"
        animationData={LoadingAnimation}
        loop={true}
        style={{ width: 60, height: 60 }}
      />
    </div>
  );
};

export default Loading;
